<template>
    <p v-if="(sportTypes && sportTypes.length) || $slots.default" class="flex font-heading text-soft mb-0 w-full">
        <slot></slot>
        <span v-if="sportTypesText" :class="truncateClassName">{{ sportTypesText }}</span>
    </p>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import type {SportTypePreview} from '@spoferan/spoferan-ts-core';

const props = defineProps<{
	sportTypes?: SportTypePreview[],
	truncate?: true | 1 | 2 | 3
}>();

const sportTypesText = computed(() => {
	if (!props.sportTypes || !props.sportTypes.length) {
		return null
	}

	return props.sportTypes.map((sportType: SportTypePreview) => sportType.title).join(' · ');
});

const truncateClassName = computed(() => {
	switch (props.truncate) {
		case true:
		case 1:
			return 'truncate';
		case 2:
			return 'truncate-2-lines';
		case 3:
			return 'truncate-3-lines';
		default:
			return null;
	}
})
</script>